import { render, staticRenderFns } from "./MatterbridgeIntegration.vue?vue&type=template&id=26466f7a&scoped=true"
import script from "./MatterbridgeIntegration.vue?vue&type=script&lang=js"
export * from "./MatterbridgeIntegration.vue?vue&type=script&lang=js"
import style0 from "./MatterbridgeIntegration.vue?vue&type=style&index=0&id=26466f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26466f7a",
  null
  
)

export default component.exports